import { Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
@Component({
  selector: 'sous-connection-template',
  templateUrl: './connection-template.component.html',
  styleUrls: ['./connection-template.component.scss']
})
export class ConnectionTemplateComponent extends FieldType<FieldTypeConfig> implements OnInit {


  ngOnInit(): void {
  }

}
